import { Icon } from '@/components/ui/icon';
import { Button } from '@/components/ui/button';

interface ShopCheckoutErrorScreenProps {
  headerTitle: string;
  title: string;
  message: string;
  retryLabel: string;
  onRetry: () => void;
  retrying?: boolean;
}

/**
 * Full-screen error state (Figma: Checkout - payment error) shown in place of
 * the payment-loading animation or the order-confirmed page when the backend
 * can't complete/confirm the checkout. Reuses ShopCheckoutScreen's header.
 */
export function ShopCheckoutErrorScreen({
  headerTitle,
  title,
  message,
  retryLabel,
  onRetry,
  retrying = false,
}: ShopCheckoutErrorScreenProps) {
  return (
    <div className="pt-safe-area relative flex min-h-screen w-full flex-col bg-white">
      <header className="flex h-13 shrink-0 items-center justify-center">
        <h1 className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[14px] leading-none font-normal tracking-[0.5px] uppercase">
          {headerTitle}
        </h1>
      </header>

      <div className="flex flex-1 flex-col items-center justify-between px-4 pt-30 pb-[calc(3rem+env(safe-area-inset-bottom))]">
        <div className="flex flex-col items-center gap-2 text-center">
          <Icon name="warning-circle" width={20} height={20} className="text-jncquoi-neutral-1000" />
          <h2 className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-xs font-normal tracking-wide uppercase">
            {title}
          </h2>
          <p className="font-pp-neue-montreal text-jncquoi-neutral-800 text-sm font-normal tracking-wide">
            {message}
          </p>
        </div>

        <Button
          variant="primary-solid"
          palette="dark"
          size="lg"
          className="w-full"
          loading={retrying}
          onClick={onRetry}
        >
          {retryLabel}
        </Button>
      </div>
    </div>
  );
}
